import React from 'react';
import { Redirect } from 'react-router-dom';
import { Route, RouteProps } from '@modernhealth/web-analytics';
import { connect } from 'react-redux';

interface ProtectedRouteProps extends RouteProps {
  component: React.ComponentType<any>;
  isAuthenticated: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  isAuthenticated,
  analytics,
  ...rest
}) => (
  <Route
    {...rest}
    analytics={analytics}
    render={(props) =>
      isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            search: `?next=${props.location.pathname}`,
          }}
        />
      )
    }
  />
);

const mapState = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
});

export default connect(mapState)(ProtectedRoute);
